import {
    getDataUTC,
    getFormatData,
    dataResources,
    getPageTitle,
    removeHtmlTags,
    replaceRouterQueryVariables,
    getCanonicalPathByDomini
} from '@portal-internet/core';
import { getUrlCanonical } from '../Enllac/RouteResolver';
import { getImatge } from 'components/3catinfo/Imatge';
import Head from 'next/head';
import { useRouter } from 'next/router';
import __isEmpty from 'lodash/isEmpty';
import __escape from 'lodash/escape';
import { useAmp } from 'next/amp';

const _get3catCanonical = (props, router) => {
    const { nombonic, titol, routePath } = props;
    let url;
    const slug = !__isEmpty(nombonic) ? nombonic : titol;
    if (routePath) {
        const { id } = router.query;
        const extXXSS =
            router.query.ext === 'wi'
                ? 'ext=IM_WP_F4_V01_CE45_'
                : router.query.ext === 'ti'
                ? 'ext=IM_TG_F4_V01_CE45_'
                : router.query.ext !== null && router.query.ext !== undefined
                ? `ext=${router.query.ext}`
                : null;
        const baseUrl = getUrlCanonical({ slug, id, routePath });

        if (extXXSS) {
            // Verificar si la URL ya tiene parámetros
            const separator = baseUrl.includes('?') ? '&' : '?';
            url = baseUrl + separator + extXXSS;
        } else {
            url = baseUrl;
        }
    } else {
        url = router.asPath.replace('/3catinfo', '');
        const indexParams = url.indexOf('?');
        url = indexParams > 0 ? url.substring(0, indexParams) : url;
    }

    return 'https://' + dataResources.domainCCMA + '/3catinfo' + url;
};

const _getNoticiaCanonical = (props, router) => {
    const { domini } = props;
    const urlCanonical = _get3catCanonical(props, router);
    const path = getCanonicalPathByDomini(domini);

    return urlCanonical.replace('/3catinfo/', `/${path}/`);
};

const _getAutorCanonical = (props, router) => {
    const { domini, routePath } = props;

    const routePaths = {
        TVC: 'item_autor_tv3',
        PUCR: 'item_autor_catradio'
    };

    const routePathAutor = routePaths[domini] ?? routePath;
    const urlCanonical = _get3catCanonical({ ...props, routePath: routePathAutor }, router);

    return routePaths[domini] ? urlCanonical.replace('https://www.3cat.cat/3catinfo', '') : urlCanonical;
};

const _getUrlCanonical = (props, router) => {
    const { canonical, layout } = props;

    if (layout === 'noticia') return _getNoticiaCanonical(props, router);
    if (layout === 'autor') return _getAutorCanonical(props, router);

    return canonical !== undefined ? canonical : _get3catCanonical(props, router);
};

const _getUrlCanonicalNoticiaAmp = (props, router) => {
    const { nombonic } = props;
    let url;
    const routePath = 'web_actualitat_item_noticia_amp';
    const { id } = router.query;
    url = getUrlCanonical({ slug: nombonic, id, routePath });
    return 'https://' + dataResources.domainCCMA + '/3catinfo' + url;
};

const _getNoIndex = (unavailableAfter, estat, font) => {
    const now = new Date();
    unavailableAfter = unavailableAfter ? unavailableAfter < now : false;
    return unavailableAfter || estat === 'DESP' || font === 'sACN';
};

const _getTitolRSS = (titol, pagina) => {
    if (__isEmpty(titol) || pagina === 'Home') {
        return '3CatInfo';
    }
    return titol;
};

const _getTitol = (props) => {
    const { titol, canalsDirectesEmbedats } = props;

    let renderTitol = titol;
    if (!__isEmpty(canalsDirectesEmbedats)) {
        renderTitol = `EN DIRECTE | ${renderTitol}`;
    }

    return renderTitol;
};

export default function Metadades(props) {
    const {
        routerQuery,
        autors,
        redactor,
        titolPersonalitzat,
        titolXarxes,
        sufix,
        prefix,
        imatges,
        imagePreview,
        tipus,
        estat,
        dataCaducitat,
        dataPublicacio,
        dataModificacio,
        tematica,
        tag,
        logicaFaldo,
        urlRSS,
        pagina,
        layout,
        descripcio,
        descripcioSufix,
        metaDescripcio,
        domini,
        programaTV,
        programaRadio,
        font
    } = props;
    const isAmp = useAmp();
    const NOTICIA = 'noticia';
    const router = useRouter();
    const urlCanonical = _getUrlCanonical(props, router);
    const urlCanonicalAmp = !isAmp && layout === NOTICIA ? _getUrlCanonicalNoticiaAmp(props, router) : null;

    const getImatgeXXSS = () => {
        let img = getImatge(imatges, 'web_xxss', null, null, !!logicaFaldo)?.src;
        const faldo3catinfo = '?strip=3catinfo-1200x628';
        if (img) {
            if (logicaFaldo === NOTICIA) {
                if (((programaTV || programaRadio) && ['PUE3', 'TVC', 'PUCR'].includes(domini)) || domini === 'TVC') {
                    img = img + '?strip=3cat-1200x628';
                } else if (domini === 'PUCR') {
                    img = img + '?strip=cr-1200x628';
                } else if (domini === 'PUE3') {
                    img = img + '?strip=e3-1200x628';
                } else if (domini === 'PUSP' || domini === 'EVA') {
                    img = img + '?strip=3cat-1200x628';
                } else {
                    img = img + faldo3catinfo;
                }
            }
        } else {
            img = 'https://img.3cat.cat/multimedia/png/3/4/1757416120643_1920x1080.png';
        }
        return img;
    };
    const getFirstP = (description) => {
        if (!description) return '';
        const match = description.match(/<p(?:[^>]*?)>(.*?)<\/p>/);
        if (match && match[1]) {
            return __escape(removeHtmlTags(match[1]));
        }
        return __escape(removeHtmlTags(description));
    };

    const getDadesArticle = (autors, redactor, dataPublicacio, dataModificacio) => {
        let autor_nom,
            autor_twitter = '';
        if (autors) {
            autor_nom = autors[0].nom;
            autor_twitter = autors[0].twitter;
        } else {
            autor_nom = redactor;
        }

        return {
            autorNom: autor_nom,
            autorTwitter: autor_twitter,
            dataPublicacio: dataPublicacio && getDataUTC(dataPublicacio),
            dataModificacio: dataModificacio && getDataUTC(dataModificacio)
        };
    };

    const imgxxss = getImatgeXXSS();
    const titol = _getTitol(props);
    const titolComplet = getPageTitle(prefix, titol, sufix, '');
    const title = titolPersonalitzat || titolComplet;
    const titleXXSS = titolXarxes || titolComplet;
    const description =
        getFirstP(metaDescripcio) || getPageTitle('', descripcio.replace(/{{titol}}/g, titol), descripcioSufix, '');
    const unavailableAfter = dataCaducitat ? getFormatData(dataCaducitat) : false;
    const noIndex = _getNoIndex(unavailableAfter, estat, font);
    const webMetadataPriority = isAmp ? 'web_metadades_priority_amp' : 'web_metadades_priority';
    const imagePriority = layout === NOTICIA && getImatge(imatges, webMetadataPriority, null, null)?.src;
    const article = getDadesArticle(autors, redactor, dataPublicacio, dataModificacio, tematica);
    const isArticle = tipus === 'article';
    const formatUrlRss = replaceRouterQueryVariables(urlRSS, routerQuery);
    const formatTitolRss = _getTitolRSS(titol, pagina);

    return (
        <Head>
            <title>{title}</title>
            <meta name='description' content={description} />
            <meta name='author' content='3CatInfo' />
            {/**Facebook*/}
            <meta property='og:type' content={tipus} />
            <meta property='og:locale' content='ca_ES' />
            <meta property='og:site_name' content='3CatInfo' />
            <meta property='og:title' content={titleXXSS} />
            <meta property='og:description' content={description} />
            {imgxxss && <meta property='og:image' content={imgxxss}></meta>}
            {imgxxss && logicaFaldo === NOTICIA && <meta property='og:image:width' content='1200' />}
            {imgxxss && logicaFaldo === NOTICIA && <meta property='og:image:height' content='628' />}
            <meta property='og:url' content={urlCanonical} />
            {/**Facebook article*/}
            {isArticle && <meta property='article:publisher' content='https://www.facebook.com/3catinfo' />}
            {isArticle && article.dataPublicacio && <meta property='article:published_time' content={article.dataPublicacio} />}
            {isArticle && article.dataModificacio && <meta property='article:modified_time' content={article.dataModificacio} />}
            {isArticle && article.autorNom && <meta property='article:author' content={article.autorNom} />}
            {isArticle && tematica && <meta property='article:section' content={tematica} />}
            {isArticle && tag && <meta property='article:tag' content={tag} />}

            {/**Twitter*/}
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={titleXXSS} />
            <meta name='twitter:description' content={description} />
            <meta name='twitter:site' content='@3catinfo'></meta>
            {article.autorTwitter && <meta name='twitter:creator' content={article.autorTwitter} />}
            {imgxxss && <meta name='twitter:image' content={imgxxss}></meta>}
            {imgxxss && <meta name='twitter:image:src' content={imgxxss}></meta>}
            <meta name='twitter:url' content={urlCanonical} />
            {/*Canonical*/}
            {urlCanonical && <link rel='canonical' href={urlCanonical} />}
            {urlCanonicalAmp && <link rel='amphtml' href={urlCanonicalAmp} />}
            {imagePreview && <meta name='robots' content='max-image-preview:large'></meta>}
            {noIndex && <meta name='robots' content='noindex'></meta>}
            {unavailableAfter && <meta name='googlebot' content={'unavailable_after: ' + unavailableAfter}></meta>}
            {imagePriority && <link rel='preload' fetchPriority='high' as='image' href={imagePriority}></link>}
            {!__isEmpty(formatUrlRss) && (
                <link
                    type='application/rss+xml'
                    rel='alternate'
                    title={formatTitolRss + ' - RSS de les notícies de 3CatInfo'}
                    href={formatUrlRss}
                />
            )}
        </Head>
    );
}

Metadades.defaultProps = {
    titol: 'Notícies al 3CatInfo - 324',
    descripcio: "L'actualitat al 3CatInfo",
    tipus: 'website',
    imagePreview: false,
    titolPersonalitzat: '',
    titolXarxes: '',
    titolPrograma: '',
    titolTag: '',
    metaDescripcio: '',
    noIndex: false
};
